import { createWebHashHistory, createRouter } from 'vue-router'
import routes from './routes'

const router = createRouter({
    history: createWebHashHistory(),
    routes,
})

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem("token")
    const role = localStorage.getItem("role")
    const alreadyCleared = localStorage.getItem('authCleared')

    if (!alreadyCleared) {
        localStorage.removeItem('token')
        localStorage.removeItem('role')
        localStorage.removeItem('me')

        // Belgilaymizki, tozalash allaqachon bajarilgan
        localStorage.setItem('authCleared', 'true')
    }

    if (to.path !== '/auth/sign-in' && from.path !== '/auth/sign-in' && !token) {
        next('/auth/sign-in')
        return
    }

    if (to.path === '/' && from.path === '/' && !token) {
        next('/auth/sign-in')
        return
    }

    if (to.path === '/' && from.path === '/' && token) {
        switch (role) {
            case 'ADMIN':
                next('/cabinet/admin/appeals')
                break
            case 'OPERATOR':
                next('/cabinet/operator/appeals')
                break
            case 'CATEGORY':
                next('/cabinet/category/appeals')
                break
            case 'REGION':
                next('/cabinet/region/appeals')
                break
            case 'DISTRICT':
                next('/cabinet/district/appeals')
                break
            case 'MINISTRY':
                next('/cabinet/ministry/appeals')
                break
            case 'VIEWER':
                next('/cabinet/viewer/appeals')
                break
            case 'DOC-ADMIN':
                next('/cabinet/doc-admin/docs')
                break
            default:
                next('/auth/sign-in')
        }
        return
    }

    next()
})

export default router